<section id="home1" class="half-height d-flex justify-content-start align-items-center flex-column position-relative">
  <div class="bg-image">
  </div>
  <div class="bannerText text-center d-flex justify-content-start align-items-center flex-column">
    <h1>Something went wrong</h1>
    <hr class="mb-4" />
  </div>
</section>
